import apiRouteRequest from "./apiRouteRequest";

export const servicePostValhallaRoute = async (payload) => {
    return apiRouteRequest({
        path: "/route",
        method: "POST",
        body: payload
    });
}